import script from "./NoCandidate.functional.vue?vue&type=script&setup=true&lang=js"
export * from "./NoCandidate.functional.vue?vue&type=script&setup=true&lang=js"

import "./NoCandidate.functional.vue?vue&type=style&index=0&id=38ce7727&lang=scss"

const __exports__ = script;

export default __exports__